/* eslint-disable camelcase */
import React from 'react'
import { colors } from '@lmc/common/constants'
import { CbSubscription } from '@lmc/common/types'
import Plan from './components/Plan'
import Status from './components/Status'
import Price from './components/Price'
import BillingDate from './components/BillingDate'

type SubscriptionTableRowProps = {
  sub: CbSubscription
}

const styles = {
  container: { marginTop: 32 },
  rounderContainer: {
    backgroundColor: colors.white,
    borderRadius: 15,
    marginBottom: 12,
  },
  subscriptionContainer: {
    display: 'flex',
    margin: 12,
    textAlign: 'center' as const,
    alignItems: 'center',
    padding: '18px 0',
  },
  flex: { flex: 1 },
}

export const SubscriptionTableRow = ({ sub }: SubscriptionTableRowProps) => (
  <div style={styles.rounderContainer}>
    <div style={styles.subscriptionContainer}>
      <div style={styles.flex}>
        <Plan
          planId={sub?.subscription_items?.[0]?.item_price_id || sub?.plan_id}
        />
      </div>
      <div style={styles.flex}>
        <Status sub={sub} />
      </div>
      <div style={styles.flex}>
        <Price sub={sub} />
      </div>
      <div style={styles.flex}>
        <BillingDate sub={sub} />
      </div>
    </div>
  </div>
)

export default SubscriptionTableRow
